import { PreloadAllModules, RouterModule, Routes } from "@angular/router";

import { AccountDashComponent } from "./client/account/account-dash/account-dash.component";
import { AppsDashComponent } from "./client/apps/apps-dash/apps-dash.component";
import { AppsEditComponent } from "./client/apps/apps-edit/apps-edit.component";
import { AuthGuard } from "./shared/guards/auth.guard";
import { BanksComponent } from "./client/account/banks/banks.component";
import { CashoutApproveEmailComponent } from "./client/cashout/cashout-approve-email/cashout-approve-email.component";
import { CashoutApproveOtpComponent } from "./client/cashout/cashout-approve-otp/cashout-approve-otp.component";
import { CashoutApprovedComponent } from "./client/cashout/cashout-approved/cashout-approved.component";
import { CashoutPendingComponent } from "./client/cashout/cashout-pending/cashout-pending.component";
import { CashoutRejectedComponent } from "./client/cashout/cashout-rejected/cashout-rejected.component";
import { CashouthomeComponent } from "./client/cashout/cashouthome/cashouthome.component";
import { ChangePasswordComponent } from "./client/change-password/change-password.component";
import { DocumentsComponent } from "./client/account/documents/documents.component";
import { LoginComponent } from "./login/login.component";
import { LoginLockedComponent } from "./login-locked/login-locked.component";
import { LoginOtpComponent } from "./login-otp/login-otp.component";
import { LoginPasswordComponent } from "./login-password/login-password.component";
import { LoginVerificationComponent } from "./login-verification/login-verification.component";
import { MainDashComponent } from "./client/main-dash/main-dash.component";
import { NgModule } from "@angular/core";
import { ProfileComponent } from "./client/account/profile/profile.component";
import { RegisterComponent } from "./client/register/register.component";
import { ResetpasswordComponent } from "./resetpassword/resetpassword.component";
import { StaffGuard } from "./shared/guards/staff/staff.guard";
import { SubusersComponent } from "./client/account/subusers/subusers.component";
import { SubusersCreateComponent } from "./client/account/subusers-create/subusers-create.component";
import { SubusersEditComponent } from "./client/account/subusers-edit/subusers-edit.component";
import { SubusersListComponent } from "./client/account/subusers-list/subusers-list.component";
import { TransDetailsComponent } from "./client/trans-details/trans-details.component";
import { TransOtherDetailsComponent } from "./client/trans-other-details/trans-other-details.component";
import { WalletsComponent } from "./client/account/wallets/wallets.component";

const routes: Routes = [
  /*{
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full'
  },*/
  ////  Auth Routes ////
  {
    path: "register",
    component: RegisterComponent,
  },
  {
    path: "register/:referralcode",
    component: RegisterComponent,
  },
  {
    path: "login",
    component: LoginComponent,
    runGuardsAndResolvers: "always",
  },
  {
    path: "login/verify-password",
    component: LoginPasswordComponent,
    runGuardsAndResolvers: "always",
  },
  {
    path: "login/validate-credentials",
    component: LoginVerificationComponent,
  },
  {
    path: "login/verify-otp",
    component: LoginOtpComponent,
  },
  {
    path: "login/account-locked",
    component: LoginLockedComponent,
  },
  {
    path: "login/resetpassword",
    component: ResetpasswordComponent,
  },

  ////  Main Dashboard  ////

  {
    path: "account/change-password",
    component: ChangePasswordComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "dashboard",
    component: MainDashComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "account",
    component: AccountDashComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "account/subusers/create",
    component: SubusersCreateComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "account/subusers/list",
    component: SubusersComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "account/subusers/:userid/edit",
    component: SubusersEditComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "account/banks",
    component: BanksComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "account/banks/:bankid/edit",
    component: BanksComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "account/wallets",
    component: WalletsComponent,
    canActivate: [AuthGuard],
  },

  {
    path: "account/wallets/:walletid/edit",
    component: WalletsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "account/profile",
    component: ProfileComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "apps",
    component: AppsDashComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "apps/edit",
    component: AppsEditComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "apps/:appid/edit",
    component: AppsEditComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "trans",
    component: TransDetailsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "transdetails/:transid",
    component: TransOtherDetailsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "cashout",
    component: CashouthomeComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "cashout/pending",
    component: CashoutPendingComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "cashout/approved",
    component: CashoutApprovedComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "cashout/rejected",
    component: CashoutRejectedComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "cashout/:transid/approve",
    component: CashoutApproveOtpComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "cashout/approve",
    component: CashoutApproveEmailComponent,
    canActivate: [AuthGuard],
  },

  ////  Catch all other routes and redirect to Dashboard  ////
  {
    path: "**",
    redirectTo: "dashboard",
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      onSameUrlNavigation: "reload",
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts